import React, { useCallback, useEffect, useState } from 'react';
import { urlApiProd } from '../utiles';

const etiquetaPi = (pi, clientes) => {
  if (!pi) return '';
  const cliente = (clientes || []).find((c) => c.id_cliente === pi.cliente);
  return `${pi.id_pi || `PI #${pi.id_proforma}`}${cliente ? ` - ${cliente.nombre}` : ''}`;
};

// PI que cubre una OC con los HC de la OC destinados a cada una. Solo para OC ya guardadas.
const OrdenCompraProformas = ({ ordencompra, proformas, clientes }) => {
  const [vinculos, setVinculos] = useState([]);
  const [hcEditados, setHcEditados] = useState({});
  const [idProforma, setIdProforma] = useState('');
  const [hcNuevo, setHcNuevo] = useState('');

  const headers = useCallback(() => ({
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  }), []);

  const cargar = useCallback(async () => {
    try {
      const res = await fetch(`${urlApiProd}/ordencompraproforma/${ordencompra.id_ordencompra}`, { headers: headers() });
      if (!res.ok) throw new Error('No se pudieron cargar las PI vinculadas');
      const datos = await res.json();
      setVinculos(datos);
      setHcEditados(Object.fromEntries(datos.map((v) => [v.id, String(v.hc)])));
    } catch (error) {
      console.error('Error al cargar PI vinculadas:', error.message);
    }
  }, [ordencompra.id_ordencompra, headers]);

  useEffect(() => { cargar(); }, [cargar]);

  const enviar = async (metodo, ruta, cuerpo) => {
    const res = await fetch(`${urlApiProd}${ruta}`, {
      method: metodo,
      headers: headers(),
      body: cuerpo ? JSON.stringify(cuerpo) : undefined,
    });
    const datos = await res.json().catch(() => ({}));
    if (!res.ok) {
      alert(datos.error || 'No se pudo completar la operación');
      return false;
    }
    await cargar();
    return true;
  };

  const vincular = async () => {
    const hc = parseInt(hcNuevo, 10);
    if (!idProforma || !hc || hc <= 0) {
      alert('Seleccione la PI e ingrese un HC entero mayor a cero.');
      return;
    }
    const ok = await enviar('POST', '/ordencompraproforma', {
      id_ordencompra: ordencompra.id_ordencompra,
      id_proforma: parseInt(idProforma, 10),
      hc,
    });
    if (ok) {
      setIdProforma('');
      setHcNuevo('');
    }
  };

  const guardarHc = (vinculo) => {
    const hc = parseInt(hcEditados[vinculo.id], 10);
    if (!hc || hc <= 0) {
      alert('Ingrese un HC entero mayor a cero.');
      return;
    }
    enviar('PUT', `/ordencompraproforma/${vinculo.id}`, { hc });
  };

  const eliminar = (vinculo) => {
    if (window.confirm('¿Quitar esta PI de la OC?')) enviar('DELETE', `/ordencompraproforma/${vinculo.id}`);
  };

  const vinculados = vinculos.reduce((suma, v) => suma + v.hc, 0);
  const idsVinculados = new Set(vinculos.map((v) => v.id_proforma));
  const disponibles = (proformas || []).filter((p) => p.id_pi && !idsVinculados.has(p.id_proforma));

  return (
    <div className="mb-3">
      <label className="form-label fw-semibold">PI vinculadas (HC por PI)</label>
      {!ordencompra.hc ? (
        <div className="text-muted small">Guarde la OC con su HC para poder vincular PI.</div>
      ) : (
        <>
          <div className="text-muted small mb-2">
            HC de la OC: {ordencompra.hc} · Vinculados: {vinculados} · Disponibles: {ordencompra.hc - vinculados}
          </div>
          {vinculos.map((v) => (
            <div className="input-group mb-2" key={v.id}>
              <span className="input-group-text flex-grow-1 text-start">
                {etiquetaPi(proformas.find((p) => p.id_proforma === v.id_proforma) || { id_pi: v.id_pi, id_proforma: v.id_proforma }, clientes)}
              </span>
              <input
                type="number"
                min="1"
                step="1"
                className="form-control"
                style={{ maxWidth: 110 }}
                value={hcEditados[v.id] ?? ''}
                onChange={(e) => setHcEditados((actual) => ({ ...actual, [v.id]: e.target.value }))}
              />
              <button type="button" className="btn btn-outline-primary" onClick={() => guardarHc(v)}>Guardar</button>
              <button type="button" className="btn btn-outline-danger" onClick={() => eliminar(v)}>Quitar</button>
            </div>
          ))}
          <div className="input-group">
            <select className="form-select" value={idProforma} onChange={(e) => setIdProforma(e.target.value)}>
              <option value="">Seleccione una PI</option>
              {disponibles.map((p) => (
                <option key={p.id_proforma} value={p.id_proforma}>{etiquetaPi(p, clientes)}</option>
              ))}
            </select>
            <input
              type="number"
              min="1"
              step="1"
              className="form-control"
              style={{ maxWidth: 110 }}
              placeholder="HC"
              value={hcNuevo}
              onChange={(e) => setHcNuevo(e.target.value)}
            />
            <button type="button" className="btn btn-outline-primary" onClick={vincular}>Vincular PI</button>
          </div>
        </>
      )}
    </div>
  );
};

export default OrdenCompraProformas;
